/**
 * BotIcon - Visual indicator for AI players
 */

import { memo } from 'react';
import clsx from 'clsx';

interface BotIconProps {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

export const BotIcon = memo(function BotIcon({ size = 'md', className }: BotIconProps) {
  const sizeClasses = {
    xs: 'w-2.5 h-2.5',
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5',
  };

  return (
    <svg
      className={clsx(sizeClasses[size], className)}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Robot head */}
      <rect x="3" y="8" width="18" height="12" rx="2" />
      {/* Antenna */}
      <path d="M12 8V4" />
      <circle cx="12" cy="3" r="1" fill="currentColor" />
      {/* Eyes */}
      <circle cx="8" cy="13" r="1.5" fill="currentColor" />
      <circle cx="16" cy="13" r="1.5" fill="currentColor" />
      {/* Mouth */}
      <path d="M9 17h6" />
    </svg>
  );
});
